<div class="basicarticle-admin">
  <sc-padding fitHeight>
    <sc-flex vertical fitHeight stretchContent>
      <sc-title>
        <sc-dictionary-label dictionaryKey="erp.ui.basicarticle.title"></sc-dictionary-label>
        <sc-content-spacer></sc-content-spacer>
        <button mat-stroked-button (click)="onCreateNewBasicArticle()" [disabled]="selectedArticleType == null">
          <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
          <sc-dictionary-label dictionaryKey="erp.ui.basicarticle.action.new"></sc-dictionary-label>
        </button>
      </sc-title>

      <sc-content-spacer vertical></sc-content-spacer>

      <sc-bordered-tile>
        <sc-padding>
          <form [formGroup]="formGroup" class="no-field-space">
            <!-- Select Box mit allen ArticleTypes -->
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="erp.entity.articletype.name"></sc-dictionary-label>
              </mat-label>
              <mat-select formControlName="articleTypeControl" [value]="selectedArticleType">
                @for (source of articleTypes; track source) {
                  <mat-option [value]="source">
                    {{source.title}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        </sc-padding>
      </sc-bordered-tile>

      <sc-content-spacer vertical [double]="true"></sc-content-spacer>

      <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
          @if (datasource.data.length > 0) {
            <sc-bordered-tile>
              <sc-padding>
                <!-- Table mit BasicArticles -->
                <div class="basicarticles">
                  <table mat-table [dataSource]="datasource" matSort (matSortChange)="announceSortChange($event)">
                    @for (disCol of columnNames; track disCol; let colIndex = $index) {
                      <ng-container matColumnDef="{{disCol}}">
                        @if (disCol != 'actions') {
                          <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
                          <td mat-cell *matCellDef="let element" class="text-selection"> {{element[disCol]}} </td>
                        }
                        @if (disCol == 'actions') {
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="editBasicArticle(element.basicArticle)"><sc-icon iconClass="fa-pencil"></sc-icon></button>
                          </td>
                        }
                      </ng-container>
                    }
                    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
                  </table>
                </div>
              </sc-padding>
            </sc-bordered-tile>
          }

        </sc-scroll-pane>
      </sc-flex-fitting-content>

    </sc-flex>
  </sc-padding>
</div>
